window.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('balance-topup-form');
    if (!form) {
        return;
    }

    const amountInput = document.getElementById('balance-topup-amount');
    const referenceInput = document.getElementById('customer-reference');
    const presetButtons = Array.from(document.querySelectorAll('.balance-page__preset'));
    const minTopup = Number(form.dataset.minTopup || 0);
    const validityMessage = form.dataset.validityMessage || '';
    const confirmMessage = form.dataset.confirmMessage || '';
    const currentBalance = Number(form.dataset.currentBalance || 0);
    const confirmModalEl = document.getElementById('balance-topup-confirm-modal');
    const confirmSubmit = document.getElementById('balance-topup-confirm-submit');
    const currentBalanceEl = confirmModalEl ? confirmModalEl.querySelector('[data-balance-current]') : null;
    const topupBalanceEl = confirmModalEl ? confirmModalEl.querySelector('[data-balance-topup]') : null;
    const referenceEl = confirmModalEl ? confirmModalEl.querySelector('[data-personal-reference]') : null;
    const afterBalanceEl = confirmModalEl ? confirmModalEl.querySelector('[data-balance-after]') : null;

    if (!amountInput || !referenceInput || !Number.isFinite(minTopup) || minTopup <= 0) {
        return;
    }

    if (confirmModalEl && confirmModalEl.parentNode !== document.body) {
        document.body.appendChild(confirmModalEl);
    }

    let confirmModal = null;
    let confirmedSubmit = false;

    const getConfirmModal = () => {
        if (!confirmModalEl) {
            return null;
        }

        if (confirmModal) {
            return confirmModal;
        }

        if (window.bootstrap && window.bootstrap.Modal) {
            confirmModal = window.bootstrap.Modal.getOrCreateInstance(confirmModalEl);
        }

        return confirmModal;
    };

    const formatEuro = (value) => new Intl.NumberFormat('en-NL', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value);

    const parseAmount = (rawAmount) => {
        const normalizedAmount = String(rawAmount === undefined || rawAmount === null ? '' : rawAmount).trim().replace(/\s+/g, '').replace(/,/g, '.');
        if (normalizedAmount === '') {
            return null;
        }

        const amount = Number(normalizedAmount);
        if (!Number.isFinite(amount)) {
            return null;
        }

        return amount;
    };

    const renderConfirmationValues = () => {
        const amount = parseAmount(amountInput.value);
        const topupAmount = amount !== null && amount > 0 ? amount : 0;
        const balanceAfter = Math.max(0, currentBalance + topupAmount);
        const reference = referenceInput.value;

        if (currentBalanceEl) {
            currentBalanceEl.textContent = formatEuro(currentBalance);
        }
        if (topupBalanceEl) {
            topupBalanceEl.textContent = formatEuro(topupAmount);
        }
        if (referenceEl) {
            referenceEl.textContent = reference !== '' ? reference : '-';
        }
        if (afterBalanceEl) {
            afterBalanceEl.textContent = formatEuro(balanceAfter);
        }
    };

    const updateQuantity = () => {
        const amount = parseAmount(amountInput.value);
        if (amount === null || amount < minTopup) {
            amountInput.setCustomValidity(validityMessage);
            return false;
        }

        amountInput.setCustomValidity('');
        return true;
    };

    presetButtons.forEach((button) => {
        button.addEventListener('click', () => {
            amountInput.value = button.dataset.amount || '';
            updateQuantity();
            renderConfirmationValues();
        });
    });

    amountInput.addEventListener('input', () => {
        updateQuantity();
        renderConfirmationValues();
    });

    form.addEventListener('submit', (event) => {
        if (confirmedSubmit) {
            confirmedSubmit = false;
            return;
        }

        if (!updateQuantity()) {
            event.preventDefault();
            amountInput.reportValidity();
            return;
        }

        const normalizedAmount = parseAmount(amountInput.value);
        if (normalizedAmount !== null) {
            amountInput.value = normalizedAmount.toString();
        }

        event.preventDefault();
        renderConfirmationValues();
        const modalInstance = getConfirmModal();
        if (modalInstance) {
            modalInstance.show();
            return;
        }

        window.setTimeout(() => {
            const delayedModalInstance = getConfirmModal();
            if (delayedModalInstance) {
                delayedModalInstance.show();
            // eslint-disable-next-line no-alert
            } else if (window.confirm(confirmMessage)) {
                confirmedSubmit = true;
                form.submit();
            }
        }, 0);
    });

    if (confirmSubmit) {
        confirmSubmit.addEventListener('click', () => {
            if (!updateQuantity()) {
                amountInput.reportValidity();
                return;
            }

            const normalizedAmount = parseAmount(amountInput.value);
            if (normalizedAmount !== null) {
                amountInput.value = normalizedAmount.toString();
            }

            confirmedSubmit = true;
            const modalInstance = getConfirmModal();
            if (modalInstance) {
                modalInstance.hide();
            }
            form.submit();
        });
    }

    updateQuantity();
    renderConfirmationValues();
});
